"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractClassException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractClassException"));

var _AbstractMethodException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractMethodException"));

var _ComponentException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ComponentException"));

var _ComponentBody = _interopRequireDefault(require("./dom/ComponentBody"));

var _ComponentDom = _interopRequireDefault(require("./dom/ComponentDom"));

var _ComponentPropHandler = _interopRequireDefault(require("./prop/ComponentPropHandler"));

var _ComponentEventHandler = _interopRequireDefault(require("./event/ComponentEventHandler"));

var _ComponentCacheStore = _interopRequireDefault(require("./utility/ComponentCacheStore"));

var _ComponentResizeHandler = _interopRequireDefault(require("./utility/ComponentResizeHandler"));

var _ComponentAttributeObserver = _interopRequireDefault(require("./utility/ComponentAttributeObserver"));

var _ComponentSettings = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/settings/ComponentSettings"));

require("@ikea-aoa/ikea-shared-styles/lib/ComponentStyle.css");

require("@ikea-aoa/ikea-shared-styles/lib/Icons.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_EVENTS = ['load', 'render'];
var FUNCTION_CALL_REGEXP = /="this\.([a-zA-Z0-9$_.]*)\(/g;
/**
 * IKEA Components should extend this class.
 */

var AbstractComponent = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {Element} element The associated element
   */
  function AbstractComponent(element) {
    var _this = this;

    _classCallCheck(this, AbstractComponent);

    if (this.constructor === AbstractComponent) {
      throw new _AbstractClassException.default();
    }

    if (!(element instanceof Element)) {
      throw new _ComponentException.default('Missing mandatory attribute "element" in the constructor. Are you passing the "element" attribute to super() correctly in constructor declaration? Super should be called like this: super(element);', this);
    }

    this.element = element;
    this.uniqueId = this.constructor._generateUniqueId();
    this.body = new _ComponentBody.default(this.constructor.componentName, Array.from(this.element.childNodes));
    this.resizeHandler = new _ComponentResizeHandler.default(this.constructor.name);
    this.isDestroyed = false;
    this.settings = _ComponentSettings.default;
    this.element.innerHTML = '';
    this.dom = new _ComponentDom.default(element, this.body, this.uniqueId);
    this.attributeObserver = new _ComponentAttributeObserver.default(this.constructor.componentName, element);
    this.propHandler = new _ComponentPropHandler.default({
      supportedProps: this.constructor.supportedProps,
      element: element,
      componentName: this.constructor.componentName,
      cacheStore: this.constructor.cacheStore,
      objectParser: function objectParser(methodName, value) {
        return typeof _this[methodName] === 'function' ? _this[methodName](value) : undefined;
      }
    });
    this.eventHandler = new _ComponentEventHandler.default({
      supportedEvents: this.constructor.supportedEvents.concat(this.constructor._defaultEvents),
      componentName: this.constructor.componentName,
      cacheStore: this.constructor.cacheStore,
      scope: this
    });
    this.attributeObserver.on('change', this._handleAttributesChanged.bind(this));
    this.propHandler.on('propsWillChange', this.propsWillChange.bind(this));
    this.propHandler.on('propsHasChanged', this.propsHasChanged.bind(this));
    this._isComponentMounted = false;
    this._mockData = null;
    this._debounceTimeout = null;
    this._debounceRenderTimeout = null;
  }
  /**
   * Gets the template.
   *
   * @abstract
   * @return {Function} Template parser function.
   */


  _createClass(AbstractComponent, [{
    key: "getTemplate",
    value: function getTemplate() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Called when the component is loaded the first time.
     */

  }, {
    key: "load",
    value: function load() {}
    /**
     * Called when the component is removed. Override this to handle destruction logic.
     */

  }, {
    key: "destroy",
    value: function destroy() {}
    /**
     * Triggered before render.
     */

  }, {
    key: "beforeRender",
    value: function beforeRender() {}
    /**
     * Triggered after render.
     */

  }, {
    key: "afterRender",
    value: function afterRender() {}
    /**
     * Called before props are changed.
     *
     * @param {Object} newProps Changed props.
     */

  }, {
    key: "propsWillChange",
    value: function propsWillChange() {}
    /**
     * Called when props has been changed.
     *
     * @param {Object} newProps Changed props.
     */

  }, {
    key: "propsHasChanged",
    value: function propsHasChanged() {}
    /**
     * Renders the component.
     *
     * @param {Boolean} [forced=false] Will force rendering of child components.
     */

  }, {
    key: "render",
    value: function render() {
      var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      clearTimeout(this._debounceRenderTimeout);

      this._handleInitialLoad();

      this.beforeRender();

      this._renderDom(forced);

      this.attributeObserver.connect();
      this.afterRender();

      if (!this.isDestroyed) {
        this.trigger('render');
      }
    }
    /**
     * Wait for a render or execute a new render after a 0ms timeout. This is useful to use to avoid multiple renders.
     *
     * @param {Boolean} [forced=false] Will force rendering of child components.
     */

  }, {
    key: "debounceRender",
    value: function debounceRender() {
      var _this2 = this;

      var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      clearTimeout(this._debounceRenderTimeout);
      this._debounceRenderTimeout = setTimeout(function () {
        _this2.render(forced);
      });
    }
    /**
     * Debounces a callback.
     *
     * @param {Function} callback Callback to debounce.
     * @param {Number} [time] Time in ms. Default is 0.
     */

  }, {
    key: "debounce",
    value: function debounce(callback) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      clearTimeout(this._debounceTimeout);
      this._debounceTimeout = setTimeout(callback, time);
    }
    /**
     * Adds an event listener.
     *
     * @param {String} name Event name.
     * @param {Function} listener The listener.
     */

  }, {
    key: "on",
    value: function on(name, listener) {
      this.eventHandler.on(name, listener);
    }
    /**
     * Removes an event listener.
     *
     * @param {String} name Event name.
     * @param {Function} [listener] The listener. Will remove all listeners if not defined.
     */

  }, {
    key: "off",
    value: function off(name) {
      var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.eventHandler.off(name, listener);
    }
    /**
     * Triggers an event.
     *
     * @param {String} name Event name.
     * @param {...Object} args Arguments to send.
     */

  }, {
    key: "trigger",
    value: function trigger(name) {
      var _this$eventHandler, _this$constructor$eve;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_this$eventHandler = this.eventHandler).trigger.apply(_this$eventHandler, [name].concat(args));

      (_this$constructor$eve = this.constructor.eventHandler.trigger).call.apply(_this$constructor$eve, [this.constructor.eventHandler, name, this].concat(args));
    }
    /**
     * Handles mock object. This should overridden in sub-class if mocking is supported.
     *
     * @abstract
     * @param {Object|Null} mockData Mock config object.
     * @return {Promise|Undefined} Returns a Promise object if asynchronous.
     */

  }, {
    key: "handleMockData",
    value: function handleMockData() {
      var mockData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      throw new _AbstractMethodException.default('Failed to set mock. handleMockData() has not been implemented by child class. Mock data: ' + mockData);
    }
    /**
     * Sets a config used with configurable properties used when mocking.
     *
     * @param {Object} mockData Mock data object.
     * @return {Promise|Undefined} Returns a Promise object if asynchronous.
     */

  }, {
    key: "setMockData",
    value: function setMockData(mockData) {
      var _iterator = _createForOfIteratorHelper(this.constructor.supportedMocks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var supportedMock = _step.value;

          if (!supportedMock.validate(mockData[supportedMock.name])) {
            throw new _ComponentException.default('The mock with name "' + supportedMock.name + '" is not in a valid format.', this);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._mockData = mockData;
      return this.handleMockData(mockData);
    }
    /**
     * Returns an object that can configurable properties used when mocking.
     *
     * @return {Object} Mock config object.
     */

  }, {
    key: "getMockData",
    value: function getMockData() {
      if (!this._mockData) {
        this._mockData = {};

        var _iterator2 = _createForOfIteratorHelper(this.constructor.supportedMocks),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var supportedMock = _step2.value;
            this._mockData[supportedMock.name] = supportedMock.defaultValue;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return this._mockData;
    }
    /**
     * Sets new props and triggers propsWillChange() and propsHasChanged().
     *
     * @param {Object} newProps Props to set as key/value. Example: { prop1: 'value1' }
     * @return {Boolean} Returns TRUE if changed.
     */

  }, {
    key: "setProps",
    value: function setProps(newProps) {
      return this.propHandler.setProps(newProps);
    }
    /**
     *
     * Updates props.
     *
     * @return {Boolean} TRUE if the props where changed.
     */

  }, {
    key: "updateProps",
    value: function updateProps() {
      this.eventHandler.updateStoredEvents(this.element.getAttribute('data-events'));
      return this.propHandler.updatePropsFromElement();
    }
    /**
     * Registers a component class to the ComponentManager.
     *
     * @param {Function} componentClass Component class to register.
     */

  }, {
    key: "registerComponentToManager",
    value: function registerComponentToManager(componentClass) {
      this.dom.componentManager.register(componentClass);
    }
    /**
     * Destroys all references to the component and calls destroy().
     */

  }, {
    key: "destroyAll",
    value: function destroyAll() {
      this._destroyTimers();

      this._destroyElement();

      this._destroyGlobalReference();

      this.dom.destroy();
      this.body.destroy();
      this.resizeHandler.destroy();
      this.attributeObserver.disconnect();
      this.destroy();

      this._destroyComponentProperties();

      this.isDestroyed = true;
    }
    /**
     * Destroys the global instance reference.
     */

  }, {
    key: "_destroyGlobalReference",
    value: function _destroyGlobalReference() {
      var uniqueId = this.uniqueId;
      var instances = this.constructor.getAllInstances();
      var instanceIndex = instances.indexOf(this);

      if (instanceIndex !== -1) {
        instances.splice(instanceIndex, 1);
      }

      window.IkeaComponent = window.IkeaComponent || {};
      window.IkeaComponent.$instances = window.IkeaComponent.$instances || {};
      delete window.IkeaComponent.$instances[uniqueId];

      if (global) {
        global.IkeaComponent = global.IkeaComponent || {};
        global.IkeaComponent.$instances = global.IkeaComponent.$instances || {};
        delete global.IkeaComponent.$instances[uniqueId];
      }
    }
    /**
     * Destroys the element.
     */

  }, {
    key: "_destroyElement",
    value: function _destroyElement() {
      if (this.body.element.parentNode) {
        this.body.element.parentNode.removeChild(this.body.element);
      }

      this.element.innerHTML = '';
      this.element.appendChild(this.body.element);
      this.element.removeAttribute('data-rendered');
      this.element.removeAttribute('data-ui-platform');
    }
    /**
     * Destroys timers.
     */

  }, {
    key: "_destroyTimers",
    value: function _destroyTimers() {
      clearTimeout(this._debounceTimeout);
      clearTimeout(this._debounceRenderTimeout);
    }
    /**
     * Destroys component properties and makes them read only.
     */

  }, {
    key: "_destroyComponentProperties",
    value: function _destroyComponentProperties() {
      var _this3 = this;

      var uniqueId = this.uniqueId;

      var _loop = function _loop(key) {
        if (_this3.hasOwnProperty(key) && key !== 'isDestroyed') {
          delete _this3[key];
          Object.defineProperty(_this3, key, {
            get: function get() {
              throw new _ComponentException.default('Call to removed component with name "' + _this3.constructor.componentName + '" (id: ' + uniqueId + '). This may indicate a memory leak. Property called: ' + key, _this3);
            }
          });
        }
      };

      for (var key in this) {
        _loop(key);
      }
    }
    /**
     * Renders the DOM.
     *
     * @param {Boolean} forced TRUE if the render should be forced.
     */

  }, {
    key: "_renderDom",
    value: function _renderDom(forced) {
      var template = this.getTemplate();

      if (typeof template !== 'function') {
        throw new _ComponentException.default('Failed to render. Expected getTemplate() to return a function.', this);
      }

      var parsedCode = template.call(this).replace(FUNCTION_CALL_REGEXP, '="IkeaComponent.$instances.' + this.uniqueId + ' && IkeaComponent.$instances.' + this.uniqueId + '.$1(');
      var templateElement = document.createElement('div');
      templateElement.innerHTML = parsedCode;
      this.dom.update(templateElement, forced);
    }
    /**
     * Handles attributes changed.
     */

  }, {
    key: "_handleAttributesChanged",
    value: function _handleAttributesChanged() {
      if (!this.propHandler.hasChangedComponentName() && this.updateProps()) {
        this.render();
      }
    }
    /**
     * Handles initial load.
     */

  }, {
    key: "_handleInitialLoad",
    value: function _handleInitialLoad() {
      if (!this._isComponentMounted) {
        this._defineGlobalReference();

        this._defineInitialAttributes();

        this._isComponentMounted = true;
        this.updateProps();
        this.propHandler.setPropsOnElement(this.props);
        this.load();
        this.trigger('load');
      }
    }
    /**
     * Defines initial element attributes.
     */

  }, {
    key: "_defineInitialAttributes",
    value: function _defineInitialAttributes() {
      this.element.setAttribute('data-rendered', 'true');
      this.element.setAttribute('name', this.constructor.componentName);

      if (this.settings.uiPlatform !== null) {
        this.element.setAttribute('data-ui-platform', this.settings.uiPlatform);
      }
    }
    /**
     * Defines a global reference to the instance.
     */

  }, {
    key: "_defineGlobalReference",
    value: function _defineGlobalReference() {
      this.constructor.getAllInstances().push(this);
      window.IkeaComponent = window.IkeaComponent || {};
      window.IkeaComponent.$instances = window.IkeaComponent.$instances || {};
      window.IkeaComponent.$instances[this.uniqueId] = this;

      if (global) {
        global.IkeaComponent = global.IkeaComponent || {};
        global.IkeaComponent.$instances = global.IkeaComponent.$instances || {};
        global.IkeaComponent.$instances[this.uniqueId] = this;
      }
    }
    /**
     * Returns the props.
     *
     * @return {Object} Props.
     */

  }, {
    key: "props",
    get: function get() {
      return this.propHandler.props;
    }
    /**
     * Defines props as an object reference.
     *
     * @param {Object} events Object with events as key/value pairs. Example: { load: () => {} }.
     * @return {String} Object reference id. The id should be defined in the "data-events" attribute of the component element.
     */

  }], [{
    key: "events",
    value: function events(_events) {
      return this.cacheStore.addEvents(_events);
    }
    /**
     * Defines props as an object reference.
     *
     * @param {Object} props Object with props as key/value pairs.
     * @return {String} Object reference id. The id should be defined in the "data-props" attribute of the component element.
     */

  }, {
    key: "props",
    value: function props(_props) {
      return this.cacheStore.addProps(_props);
    }
    /**
     * Adds an event listener.
     *
     * @param {String} name Event name.
     * @param {Function} listener The listener.
     */

  }, {
    key: "on",
    value: function on(name, listener) {
      this.eventHandler.on(name, listener);
    }
    /**
     * Removes an event listener.
     *
     * @param {String} name Event name.
     * @param {Function} [listener] The listener. It will remove all if not defined.
     */

  }, {
    key: "off",
    value: function off(name) {
      var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.eventHandler.off(name, listener);
    }
    /**
     * Triggers an event.
     *
     * @param {String} name Event name.
     * @param {...Object} args Arguments to send.
     */

  }, {
    key: "trigger",
    value: function trigger(name) {
      var _this$eventHandler2;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (_this$eventHandler2 = this.eventHandler).trigger.apply(_this$eventHandler2, [name].concat(args));
    }
    /**
     * Clears all cache.
     */

  }, {
    key: "clearCache",
    value: function clearCache() {
      this.cacheStore.clear();

      _ComponentBody.default.cacheStore.clear();
    }
    /**
     * Generates a unique id.
     *
     * @return {String} Unique id.
     */

  }, {
    key: "_generateUniqueId",
    value: function _generateUniqueId() {
      var uniqueId = this.cacheStore.get('uniqueId') || 0;
      uniqueId++;
      this.cacheStore.set('uniqueId', uniqueId);
      return this.componentName + (uniqueId > 1 ? uniqueId : '');
    }
    /**
     * Gets the default events.
     *
     * @return {String[]} Array of supported default event names. Default: ['load', 'render']
     */

  }, {
    key: "getAllInstances",

    /**
     * Returns all component instances.
     *
     * @return {AbstractComponent[]} Component instances.
     */
    value: function getAllInstances() {
      var instances = this.cacheStore.get('instances');

      if (!instances) {
        instances = [];
        this.cacheStore.set('instances', instances);
      }

      return instances;
    }
    /**
     * Returns the component name.
     *
     * @abstract
     * @return {String} Component name.
     */

  }, {
    key: "_defaultEvents",
    get: function get() {
      return DEFAULT_EVENTS;
    }
    /**
     * Returns the static event handler.
     *
     * @return {ComponentEventHandler} Event handler.
     */

  }, {
    key: "eventHandler",
    get: function get() {
      var eventHandler = this.cacheStore.get('eventHandler');

      if (!eventHandler) {
        eventHandler = new _ComponentEventHandler.default({
          supportedEvents: this.supportedEvents.concat(this._defaultEvents),
          componentName: this.componentName,
          cacheStore: this.cacheStore,
          scope: this
        });
        this.cacheStore.set('eventHandler', eventHandler);
      }

      return eventHandler;
    }
  }, {
    key: "componentName",
    get: function get() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Returns an array of supported events.
     *
     * @return {String[]} Array of supported event names. Example: ['click', 'mouseover']
     */

  }, {
    key: "supportedEvents",
    get: function get() {
      return [];
    }
    /**
     * Returns the supported props.
     *
     * @example [
     *  new SupportedProp('requiredProp', 'string', true),
     *  new SupportedProp('optionalProp', 'number')
     * ]
     * @return {SupportedProp[]} Array of supported prop objects.
     */

  }, {
    key: "supportedProps",
    get: function get() {
      return [];
    }
    /**
     * Returns the supported mocks. This should overridden in sub-class if mocking is supported.
     *
     * @example [
     *  new ('requiredMock', 'string, 'my default value', true),
     *  new SupportedMock('optionalMock', 'number', 99)
     * ]
     * @return {SupportedMock[]} Array of supported mock objects.
     */

  }, {
    key: "supportedMocks",
    get: function get() {
      return [];
    }
    /**
     * Returns the cache store.
     *
     * @return {CacheStore} Cache store.
     */

  }, {
    key: "cacheStore",
    get: function get() {
      if (!this._cacheStore) {
        this._cacheStore = new _ComponentCacheStore.default(this.componentName);
      }

      return this._cacheStore;
    }
  }]);

  return AbstractComponent;
}();

exports.default = AbstractComponent;